// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('fish_chips.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.lang-icon {
  position: fixed;
  top: 10%;
  right: 5%;
  height: 32px;
  width: 32px;
  border: 2px solid white;
  border-radius: 50%;
}

.logo-row {
  width: 100%;
}

.brand-logo {
  margin: 14% 0 10%;
  height: 11vh;
  min-height: 92px;
  max-height: 150px;
  width: 100%;
}

ion-content {
  position: relative;
  --overflow: hidden;
}

.wrapper {
  height: 100%;
  padding-inline: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
}
@media (max-width: 390px) {
  .wrapper {
    padding-top: 0;
  }
}
@media (min-width: 991px) {
  .wrapper {
    width: 640px;
    height: 100%;
  }
}
.wrapper .card {
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 16px;
}
.wrapper .title-block {
  width: 100%;
}
.wrapper .title {
  width: 100%;
  text-align: center;
  margin-bottom: 12px;
  font-family: Title;
  font-size: 50px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  color: var(--color-white);
}
@media (min-width: 991px) {
  .wrapper .title {
    padding-top: 0px;
    margin-bottom: 25px;
  }
}
.wrapper .border-line {
  width: 100%;
  height: 0px;
  border-bottom: 1px solid #69a669;
  opacity: 0.2;
  margin-bottom: 20px;
}
.wrapper .button {
  width: 100%;
}
.wrapper .button .order_method {
  opacity: 0.6;
  cursor: pointer;
  width: 100%;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}
.wrapper .button .order_method.active {
  opacity: 1;
}
.wrapper .button .order_method .method_icon {
  margin-right: 10px;
  height: 44px;
  width: 44px;
}
.wrapper .button .order_method .text_block {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-right: 10px;
}
.wrapper .button .order_method .text_block .title {
  font-family: AppFontBold;
  font-size: 18px;
  line-height: 20.7px;
  text-align: left;
  color: var(--ion-color-primary);
  margin-bottom: 6px;
}
.wrapper .button .order_method .text_block .subtitle {
  font-family: AppFont;
  font-size: 14px;
  line-height: 17.22px;
  text-align: left;
  color: var(--black-title);
}
.wrapper .button .order_method .method_select {
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #e20026;
}
@media (min-width: 991px) {
  .wrapper .button {
    width: 80%;
    padding: 0;
  }
  .wrapper .button ion-button {
    width: 100%;
    height: 58px;
  }
}
.wrapper ion-button {
  --border-width: 1px;
  --border-color: #fff;
  --border-style: solid;
}
.wrapper ion-button .button-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.wrapper ion-button .button-inner .left-block {
  display: flex;
  align-items: center;
}
.wrapper ion-button .button-inner .left-block .burger {
  height: 30px;
  width: 37px;
  margin-right: 12px;
}
.wrapper ion-button .button-inner .left-block .button-text {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-white);
}
.wrapper ion-button .button-inner .arrow-right {
  width: 20px;
  height: 20px;
}
.wrapper .payment-method {
  width: 100%;
  text-align: center;
  margin-bottom: 12px;
}
.wrapper .payment-method ion-icon {
  height: 15px;
  width: 100%;
  margin: 0 auto;
}

.payment-method-desktop {
  display: none;
}
@media (min-width: 991px) {
  .payment-method-desktop {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 35px 23px 35px;
    background-color: #83c1b1;
    margin-bottom: 80px;
  }
}
.payment-method-desktop p {
  margin: 0;
  font-family: AppFontMedium;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.01em;
  text-align: center;
  margin-bottom: 18px;
}
.payment-method-desktop ion-img {
  height: 40px;
  width: 100%;
}

.info {
  font-family: AppFont;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  color: var(--color-white);
  margin-bottom: 44px;
}

.table {
  font-family: Title;
  font-size: 40px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  color: var(--color-white);
  margin-bottom: 14px;
}

.footer-block {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-bottom: 20px;
  width: 85px;
  flex-wrap: wrap;
  gap: 5px;
}
.footer-block ion-img {
  flex-basis: 33px;
  width: 33px;
  height: 33px;
  border-radius: 50%;
  position: relative;
  z-index: 1;
  border: 2px solid transparent;
}
.footer-block ion-img.selected {
  border: 2px solid white;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.page.ahoi.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,0FAAA;EACA,4BAAA;EACA,kCAAA;EACA,sBAAA;AADD;;AAIA;EACC,eAAA;EACA,QAAA;EACA,SAAA;EAEA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;AAFD;;AAIA;EACC,WAAA;AADD;;AAGA;EACC,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAAD;;AAGA;EACC,kBAAA;EACA,kBAAA;AAAD;;AAGA;EACC,YAAA;EACA,oBAAA;EAEA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AADD;AAIC;EAXD;IAYE,cAAA;EADA;AACF;AC9CE;EDkCF;IAgBE,YAAA;IACA,YAAA;EAAA;AACF;AAEC;EACC,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAKA,kBAAA;AAJF;AAOC;EACC,WAAA;AALF;AAOC;EACC,WAAA;EACA,kBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AANF;AC5EE;EDuED;IAcE,gBAAA;IACA,mBAAA;EALD;AACF;AAOC;EACC,WAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;EACA,mBAAA;AALF;AAQC;EACC,WAAA;AANF;AAQE;EACC,YAAA;EACA,eAAA;EAEA,WAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;AARH;AAUG;EACC,UAAA;AARJ;AAWG;EACC,kBAAA;EACA,YAAA;EACA,WAAA;AATJ;AAYG;EACC,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAVJ;AAYI;EACC,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,kBAAA;AAVL;AAaI;EACC,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;AAXL;AAeG;EACC,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AAbJ;ACzIE;EDiGD;IA0DE,UAAA;IACA,UAAA;EAdD;EAeC;IACC,WAAA;IACA,YAAA;EAbF;AACF;AAiBC;EAEC,mBAAA;EACA,oBAAA;EACA,qBAAA;AAhBF;AAkBE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAhBH;AAkBG;EACC,aAAA;EACA,mBAAA;AAhBJ;AAkBI;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAhBL;AAmBI;EACC,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;AAjBL;AAqBG;EACC,WAAA;EACA,YAAA;AAnBJ;AAuBC;EACC,WAAA;EACA,kBAAA;EACA,mBAAA;AArBF;AAsBE;EACC,YAAA;EACA,WAAA;EACA,cAAA;AApBH;;AAyBA;EACC,aAAA;AAtBD;ACnME;EDwNF;IAGE,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;IACA,uBAAA;IACA,yBAAA;IACA,mBAAA;EApBA;AACF;AAsBC;EACC,SAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AApBF;AAuBC;EACC,YAAA;EACA,WAAA;AArBF;;AAyBA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;AAtBD;;AAyBA;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EAEA,mBAAA;AAvBD;;AA6BA;EACC,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,eAAA;EACA,QAAA;AA1BD;AA4BC;EACC,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,6BAAA;AA1BF;AA4BE;EACC,uBAAA;AA1BH","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n\tbackground: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(../../../assets/ahoi/fish_chips.png);\n\tbackground-repeat: no-repeat;\n\tbackground-position: center center;\n\tbackground-size: cover;\n}\n\n.lang-icon {\n\tposition: fixed;\n\ttop: 10%;\n\tright: 5%;\n\n\theight: 32px;\n\twidth: 32px;\n\tborder: 2px solid white;\n\tborder-radius: 50%;\n}\n.logo-row {\n\twidth: 100%;\n}\n.brand-logo {\n\tmargin: 14% 0 10%;\n\theight: 11vh;\n\tmin-height: 92px;\n\tmax-height: 150px;\n\twidth: 100%;\n}\n\nion-content {\n\tposition: relative;\n\t--overflow: hidden;\n}\n\n.wrapper {\n\theight: 100%;\n\tpadding-inline: 20px;\n\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tflex-direction: column;\n\tmargin: 0 auto;\n\t// padding-top: 35px;\n\n\t@media (max-width: 390px) {\n\t\tpadding-top: 0;\n\t}\n\n\t@include desktop {\n\t\twidth: 640px;\n\t\theight: 100%;\n\t}\n\n\t.card {\n\t\twidth: 100%;\n\t\tmax-width: 500px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t// background-color: #ffffffe3;\n\t\t// border-radius: var(--radius-d);\n\n\t\tpadding: 32px 16px;\n\t}\n\n\t.title-block {\n\t\twidth: 100%;\n\t}\n\t.title {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tmargin-bottom: 12px;\n\n\t\tfont-family: Title;\n\t\tfont-size: 50px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--color-white);\n\n\t\t@include desktop {\n\t\t\tpadding-top: 0px;\n\t\t\tmargin-bottom: 25px;\n\t\t}\n\t}\n\t.border-line {\n\t\twidth: 100%;\n\t\theight: 0px;\n\t\tborder-bottom: 1px solid #69a669;\n\t\topacity: 0.2;\n\t\tmargin-bottom: 20px;\n\t}\n\n\t.button {\n\t\twidth: 100%;\n\n\t\t.order_method {\n\t\t\topacity: 0.6;\n\t\t\tcursor: pointer;\n\n\t\t\twidth: 100%;\n\t\t\tmargin-bottom: 12px;\n\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t&.active {\n\t\t\t\topacity: 1;\n\t\t\t}\n\n\t\t\t.method_icon {\n\t\t\t\tmargin-right: 10px;\n\t\t\t\theight: 44px;\n\t\t\t\twidth: 44px;\n\t\t\t}\n\n\t\t\t.text_block {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tflex-grow: 1;\n\t\t\t\tmargin-right: 10px;\n\n\t\t\t\t.title {\n\t\t\t\t\tfont-family: AppFontBold;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tline-height: 20.7px;\n\t\t\t\t\ttext-align: left;\n\t\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\t\tmargin-bottom: 6px;\n\t\t\t\t}\n\n\t\t\t\t.subtitle {\n\t\t\t\t\tfont-family: AppFont;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tline-height: 17.22px;\n\t\t\t\t\ttext-align: left;\n\t\t\t\t\tcolor: var(--black-title);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.method_select {\n\t\t\t\theight: 32px;\n\t\t\t\twidth: 32px;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\tborder: 1px solid #e20026;\n\t\t\t}\n\t\t}\n\n\t\t@include desktop {\n\t\t\twidth: 80%;\n\t\t\tpadding: 0;\n\t\t\tion-button {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 58px;\n\t\t\t}\n\t\t}\n\t}\n\n\tion-button {\n\t\t// border: 1px solid #ffffff;\n\t\t--border-width: 1px;\n\t\t--border-color: #fff;\n\t\t--border-style: solid;\n\n\t\t.button-inner {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\twidth: 100%;\n\n\t\t\t.left-block {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n\t\t\t\t.burger {\n\t\t\t\t\theight: 30px;\n\t\t\t\t\twidth: 37px;\n\t\t\t\t\tmargin-right: 12px;\n\t\t\t\t}\n\n\t\t\t\t.button-text {\n\t\t\t\t\tfont-family: AppFontBold;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tline-height: 85%;\n\t\t\t\t\tletter-spacing: 0%;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tvertical-align: middle;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tcolor: var(--color-white);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.arrow-right {\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 20px;\n\t\t\t}\n\t\t}\n\t}\n\t.payment-method {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tmargin-bottom: 12px;\n\t\tion-icon {\n\t\t\theight: 15px;\n\t\t\twidth: 100%;\n\t\t\tmargin: 0 auto;\n\t\t}\n\t}\n}\n\n.payment-method-desktop {\n\tdisplay: none;\n\t@include desktop {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\t\tpadding: 35px 23px 35px;\n\t\tbackground-color: #83c1b1;\n\t\tmargin-bottom: 80px;\n\t}\n\n\tp {\n\t\tmargin: 0;\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 18px;\n\t\tline-height: 27px;\n\t\tletter-spacing: 0.01em;\n\t\ttext-align: center;\n\t\tmargin-bottom: 18px;\n\t}\n\n\tion-img {\n\t\theight: 40px;\n\t\twidth: 100%;\n\t}\n}\n\n.info {\n\tfont-family: AppFont;\n\tfont-size: 16px;\n\tline-height: 100%;\n\tletter-spacing: 0px;\n\ttext-align: center;\n\tvertical-align: middle;\n\ttext-transform: capitalize;\n\tcolor: var(--color-white);\n\tmargin-bottom: 44px;\n}\n\n.table {\n\tfont-family: Title;\n\tfont-size: 40px;\n\tline-height: 100%;\n\tletter-spacing: 0%;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\tcolor: var(--color-white);\n\n\tmargin-bottom: 14px;\n}\n\n.last_phrase {\n}\n\n.footer-block {\n\tmargin: 0 auto;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\ttext-align: center;\n\tpadding-bottom: 20px;\n\twidth: 85px;\n\tflex-wrap: wrap;\n\tgap: 5px;\n\n\tion-img {\n\t\tflex-basis: 33px;\n\t\twidth: 33px;\n\t\theight: 33px;\n\t\tborder-radius: 50%;\n\t\tposition: relative;\n\t\tz-index: 1;\n\t\tborder: 2px solid transparent;\n\n\t\t&.selected {\n\t\t\tborder: 2px solid white;\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
